export default __webpack_public_path__ + "static/media/Group9194.9b49a6d3.svg";